import { API } from './api'

export async function getMeInfo () {
  let res
  try {
    res = await API.get('me')
  } catch (e) {
    res = {
      status: 401,
      err: new Error('Cannot get user data, unauthorized access.')
    }
    window.localStorage.clear()
  }
  return res
}

export async function setNotification (id) {
  let res
  try {
    res = await API.post('me/notifications', { notificationChannel: id })
  } catch (e) {
    res = {
      status: 401,
      err: new Error('Cannot get user data, unauthorized access.')
    }
    window.localStorage.clear()
  }
  return res
}

export async function updateMeSignature (data) {
  const res = await API.put('me', {
    preferences: data
  })
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /me')
  return res
}

export async function uploadProfileImage (data) {
  const res = await API.put('media/profile-image', data)
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /media/profile-image')
  return res
}

export async function updateMeFullname (fullname) {
  const res = await API.put('me', {
    fullName: fullname,
  })

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /settings')
  return res
}

export async function updateUnlabeledVisibility (visibility) {
  const res = await API.put('me', {
    preferences: {
      isUnlabeledShown: visibility
    },
  })

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /settings')
  return res
}

export async function getCustomerBillingData () {
  const res = await API.get('me/billing')
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for GET /me/billing')
  return res.data
}

export async function cancelCustomerSubscription (type) {
  const res = await API.post('me/billing/cancel-subscription', {
    cancelType: type,
  })
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for POST /cancel-subscription')
  return res.data
}

export async function reactivateSubscription () {
  const res = await API.post('me/billing/reactivate-subscription')
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for POST /cancel-subscription')
  return res.data
}

export async function queryCancelSubscriptionData () {
  const res = await API.get('me/billing/cancel-subscription-data')
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for POST /cancel-subscription')
  return res.data
}

export async function cancelTrialSubscription () {
  const res = await API.delete('onboarding/trial-subscription')
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for POST /cancel-subscription')
  return res.data
}

export async function requestPurchaseAnotherDomainAPICall (domain) {
  const res = await API.put('me/request-purchase-another-domain', {
    domain: domain
  })
  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for POST /cancel-subscription')
  return res.data
}
